import { FC } from 'react';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';

const Bonanza: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles }) => {
  const { reDirectPage, validateClientId, updatePartialConfigs, isMobile } = brokerSpecificHandles;
  const {
    clientId,
    isClientValidated,
    shouldShowApiKey,
    shouldShowSecretKey,
    apiKey,
    secretKey,
    isValidForm,
    isLoading,
    selectedBrokerConfig,
  } = userConfigs;
  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isClientValidated ? reDirectPage({}, false) : validateClientId();
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        id={`${broker}-client-id`}
        value={clientId}
        isDisabled={isClientValidated}
        placeholder="Enter Client Id"
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />

      {shouldShowApiKey && (
        <div>
          <UserInput
            labelValue="API Key"
            id={`${broker}-api-key`}
            value={apiKey}
            placeholder="Enter API Key"
            onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
          />
        </div>
      )}

      {shouldShowSecretKey && (
        <div>
          <UserInput
            labelValue="API Secret"
            id={`${broker}-secret-key`}
            value={secretKey}
            placeholder="Enter API Secret"
            onHandleChange={(value) => updatePartialConfigs({ secretKey: value })}
          />
        </div>
      )}

      {isClientValidated && (
        <div className="alert alert-warning">
          Please contact Bonanza support to get your API Key and Secret Key
        </div>
      )}

      {!isValidForm && <div className="invalid-feedback d-block">Please provide the details!</div>}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-form`} type="submit" isLoading={isLoading}>
          {isClientValidated ? 'Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default Bonanza;
